import { render, staticRenderFns } from "./upload-video.vue?vue&type=template&id=17c91f2b&scoped=true&"
import script from "./upload-video.vue?vue&type=script&lang=js&"
export * from "./upload-video.vue?vue&type=script&lang=js&"
import style0 from "./upload-video.vue?vue&type=style&index=0&id=17c91f2b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c91f2b",
  null
  
)

export default component.exports